/* eslint-disable no-param-reassign */
/* istanbul ignore file */

import { produce } from '@lumapps/redux/immer';

import { GET_ALL_SOCIAL_NETWORKS, UPDATE_SOCIAL_NETWORK } from './actions';

const defaultState = {
    current: null,
    entities: {},
    form: {},
    isAdvancedOptionOpen: {},
};

export const reducer = produce((draft, action) => {
    switch (action.type) {
        case GET_ALL_SOCIAL_NETWORKS:
            action.socialNetworks.forEach(
                // eslint-disable-next-line no-return-assign
                (socialNetwork) => (draft.entities[socialNetwork.socialNetworkId] = socialNetwork),
            );

            return draft;

        case UPDATE_SOCIAL_NETWORK:
            Object.assign(draft.entities[action.socialNetwork.socialNetworkId], action.socialNetwork);
            draft.current = undefined;

            return draft;

        default:
            return draft;
    }
}, defaultState);
